import { render, staticRenderFns } from "./RsaAccettazioneAnagraficaComponent.vue?vue&type=template&id=decd0df2&scoped=true"
import script from "./RsaAccettazioneAnagraficaComponent.vue?vue&type=script&lang=js"
export * from "./RsaAccettazioneAnagraficaComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaAccettazioneAnagraficaComponent.vue?vue&type=style&index=0&id=decd0df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decd0df2",
  null
  
)

export default component.exports